import {
  ClientRiskReportResults,
  GetSolutionSourcingResultsResponse,
  IressCredentialsPair,
  ProtectionAuth,
  RiskReportInput,
  RiskReportResponse,
  RiskReportResultsValue,
  RunSolutionSourcingInput,
  RunSolutionSourcingResponse,
  SaveToCaseInput,
  SplitCoverBenefitsInput,
  SyncProtectionDocumentsInput
} from '../generated/resolvers'
import request from '../requesters/protection'
import requestV2 from '../requesters/protectionV2'

type ProductApplyInput = {
  case_id: string
  product_id: string
}

type ProductApplyResponse = {
  url: string
}

export const splitProductEstimate = async (body: SplitCoverBenefitsInput) => {
  const response = await request.post('/quote', body)

  return response?.data
}

export const splitProductEstimateV2 = async (body: SplitCoverBenefitsInput) => {
  const response = await requestV2.post('/quote', body)

  return response?.data
}


export const runSolutionSourcing = async (body: RunSolutionSourcingInput): Promise<RunSolutionSourcingResponse> => {


  const response = await request.post<RunSolutionSourcingResponse>('/solutions', body)
  return response?.data
}

export const runSolutionSourcingV2 = async (body: RunSolutionSourcingInput): Promise<RunSolutionSourcingResponse> => {
  const response = await requestV2.post<RunSolutionSourcingResponse>('/source', body)
  return response?.data
}

export const saveProtectionProductsToCase = async (body: SaveToCaseInput) => {
  const response = await request.post('/saveToCase', body)
  return response?.data
}

export const saveProtectionProductsToCaseV2 = async (body: SaveToCaseInput) => {
  const response = await requestV2.post('/save', body)
  return response?.data
}

export const getSolutionSourcingResults = async (location: string) => {
  // We need to remove the prefix that out API utils automatically prepend
  // to each URL, because the protection service returns a location with
  // that prefix already included.
  const prefix = '/v1/acre/protection'
  const locationWithoutPrefix = location.replace(prefix, '')
  const response = await request.get<GetSolutionSourcingResultsResponse>(decodeURIComponent(locationWithoutPrefix))
  return response?.data
}

export const getSolutionSourcingResultsV2 = async (location: string) => {
  // We need to remove the prefix that out API utils automatically prepend
  // to each URL, because the protection service returns a location with
  // that prefix already included.
  const prefix = '/v2/acre/protection'
  const locationWithoutPrefix = location.replace(prefix, '')
  const response = await requestV2.get<GetSolutionSourcingResultsResponse>(decodeURIComponent(locationWithoutPrefix))
  return response?.data
}

export const productApply = async (integratorQuoteReference: string) => {
  const response = await request.get<ProductApplyResponse>(`/products/${integratorQuoteReference}/applyDirect`)
  return response?.data
}

export const productApplyV2 = async (body: ProductApplyInput) => {
  const response = await requestV2.post<ProductApplyResponse>(`/apply`, body)
  return response?.data
}

export const checkAuthProtection = async (body: ProtectionAuth) => {
  const response = await request.post('/check_auth', body)
  return response?.data
}

export const checkAuthProtectionV2 = async (body: IressCredentialsPair) => {
  const response = await requestV2.post('/check_auth', body)
  return response?.data
}

export const syncProtectionDocuments = async (body: SyncProtectionDocumentsInput) => {
  const response = await request.post('/syncProtectionDocuments', body)

  return response?.data
}

export const syncProtectionDocumentsV2 = async (body: SyncProtectionDocumentsInput) => {
  const response = await requestV2.post('/sync_documents', body)

  return response?.data
}

export const getRiskReport = async (body: RiskReportInput) => {
  const response = await requestV2.post<RiskReportResponse>('/risk_report', body)

  const { data } = response

  // we have to reformat the response as BE is returning objects with values for the individual keys for risk report results
  // tldr: BE structure on the Client does not match the response coming from the endpoint itself
  const formattedResponse = Object.assign({}, data, {
    results: Object.entries(data.results!).reduce((acc, [key, value]) => {
      //@ts-ignore
      acc[key as keyof ClientRiskReportResults] = (value as RiskReportResultsValue)?.value
      return acc
    }, {} as ClientRiskReportResults)
  })


  return formattedResponse
}
